<template>
  <section class="about-content-boxes">
    <b-container class="h-100 gap-row">
      <b-row class="h-100 align-content-center">
        <b-col sm="12" md="6" lg="5" order="2" order-md="1">
         <div class="box-about-text">
           <h4 class="box-about-text-title">{{$t('box_title_1')}}</h4>
           <p class="box-about-text-subtitle">{{$t('box_subtitle_1')}}</p>
         </div>
        </b-col>
        <b-col sm="12" md="6" lg="7" order="1" order-md="2">
          <div class="box-about-img">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/about-page/box-1-eng.png" alt="About banner image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/about-page/box-1-ua.png" alt="About banner image">
            <img v-else class="main-photo" src="../../assets/img/about-page/box-1-eng.png" alt="About banner image">
          </div>
        </b-col>
      </b-row>
      <b-row class="h-100 align-content-center">
        <b-col sm="12" md="6" lg="7">
          <div class="box-about-img">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/about-page/box-2-eng.png" alt="About banner image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/about-page/box-2-ua.png" alt="About banner image">
            <img v-else class="main-photo" src="../../assets/img/about-page/box-2-eng.png" alt="About banner image">
          </div>
        </b-col>
        <b-col sm="12" md="6" lg="5">
          <div class="box-about-text">
            <h4 class="box-about-text-title">{{$t('box_title_2')}}</h4>
            <p class="box-about-text-subtitle">{{$t('box_subtitle_2')}}</p>
          </div>
        </b-col>
      </b-row>
      <b-row class="h-100 align-content-center">
        <b-col sm="12">
          <div class="box-about-text-center text-center">
            <h4 class="box-about-text-title">{{$t('box_title_3')}}</h4>
            <p class="box-about-text-subtitle">{{$t('box_subtitle_3')}}</p>
          </div>
        </b-col>
        <b-col sm="12">
          <div class="box-about-img-center">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/about-page/box-3-eng.png" alt="About banner image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/about-page/box-3-ua.png" alt="About banner image">
            <img v-else class="main-photo" src="../../assets/img/about-page/box-3-eng.png" alt="About banner image">
          </div>
        </b-col>
        <b-col sm="12">
          <div class="delete-link-container">
            <router-link class="delete-btn-link" to="/faq">{{$t('delete_profile')}} <span class="icon">&#x2198;</span></router-link>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/app";

section.about-content-boxes {
  padding-top: 80px;
  padding-bottom: 120px;
  .gap-row{
    gap: 40px;
    display: flex;
    flex-direction: column;
  }
  .box-about-text,
  .box-about-text-center{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    color: #30394B;
    .box-about-text-title{
      font-family: $main-font;
      font-size: 24px;
      font-weight: 700;
      line-height: 28.8px;
      margin: 0;
      @media screen and (min-width: 320px) {
        font-size: 20px;
        line-height: 120%;
      }
      @media screen and (min-width: 992px) {
        font-size: 24px;
        line-height: 28.8px;
        margin: 0;
      }
    }
    .box-about-text-subtitle{
      font-family: $main-font;
      font-size: 18px;
      font-weight: 300;
      line-height: 25.2px;
      margin: 0;
      @media screen and (min-width: 320px) {
        font-size: 16px;
        line-height: 140%;
      }
      @media screen and (min-width: 992px) {
        font-size: 18px;
        line-height: 25.2px;
      }
    }
  }
  .box-about-img {
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 320px) {
      margin-bottom: 40px;
    }
    @media screen and (min-width: 992px) {
      margin-bottom: 0;
    }
    img{
      width: 100%;
      max-width: 560px;
      height: auto;
    }
  }
  .box-about-text-center{
    width: 100%;
    max-width: 645px;
    padding: 40px 0;
    margin: 0 auto;
  }
  .box-about-img-center{
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100%;
      max-width: 760px;
      height: auto;
    }
  }
  .delete-link-container{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    margin-top: 80px;
    .delete-btn-link{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-family: $main-font;
      font-size: 18px;
      font-weight: 700;
      line-height: 28.8px;
      color: #7A7CE8;
      .icon{
        position: relative;
        top: 1.5px;
        transform: rotate(-50deg);
        font-size: 30px;
      }
      &:hover{
        text-decoration: none;
        outline: none;
        color: #5C5EE8;
      }
    }
  }
}
</style>
